// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgColor from "../../../components/svg-color";
import Iconify from "../../../components/iconify";

// ----------------------------------------------------------------------

// const icon = (name: string) => (
//   <SvgColor
//     src={`/assets/icons/navbar/${name}.svg`}
//     sx={{ width: 1, height: 1 }}
//   />
// );

// const ICONS = {
//   user: icon("ic_user"),
//   ecommerce: icon("ic_ecommerce"),
//   analytics: icon("ic_analytics"),
//   dashboard: icon("ic_dashboard"),
// };

const icon = <Iconify icon="stash:arrow-right-solid" />;

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: "",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.dashboard,
        icon,
      },
      {
        title: "Business Management",
        path: PATH_DASHBOARD["business-management"].root,
        icon,
        children: [
          {
            title: "All Busineses",
            path: PATH_DASHBOARD["business-management"].business.root,
          },
          {
            title: "Onboarding Requests",
            path: PATH_DASHBOARD["business-management"].requests.root,
          },
          {
            title: "Business Connections",
            path: PATH_DASHBOARD["business-management"].connections,
          },
        ],
      },
      {
        title: "Invoice Requests",
        path: PATH_DASHBOARD.invoices,
        icon,
      },
      {
        title: "Transactions",
        path: PATH_DASHBOARD.accounting,
        icon,
      },
      {
        title: "Billing",
        path: PATH_DASHBOARD.billing,
        icon,
      },
      {
        title: "AssuredPay Fee",
        path: PATH_DASHBOARD.fee,
        icon,
      },
      {
        title: "Activity",
        path: PATH_DASHBOARD.activity,
        icon,
      },
      {
        title: "Bank Logs",
        path: PATH_DASHBOARD.BankLogs,
        icon,
      },
      {
        title: "Sales",
        path: PATH_DASHBOARD.sales.root,
        icon,
        children: [
          {
            title: "Dashboard",
            path: PATH_DASHBOARD.sales.dashboard,
          },
          {
            title: "Sales Users",
            path: PATH_DASHBOARD.sales.users,
          },
          {
            title: "Incentive Plan",
            path: PATH_DASHBOARD.sales.incentivePlan,
          },
          {
            title: "Settlement",
            path: PATH_DASHBOARD.sales.settlement,
          },
        ],
      },
      {
        title: "Affiliate",
        path: PATH_DASHBOARD.affiliate.root,
        icon,
        children: [
          {
            title: "Dashboard",
            path: PATH_DASHBOARD.affiliate.AffiliateAnalytics,
          },
          {
            title: "All Affiliates",
            path: PATH_DASHBOARD.affiliate.list,
          },
          {
            title: "Tier Management",
            path: PATH_DASHBOARD.affiliate.tier,
          },
        ],
      },
      {
        title: "Admin Control",
        path: PATH_DASHBOARD.AdminControl,
        icon,
      },
      {
        title: "Ticket management",
        path: PATH_DASHBOARD.TicketManagement.root,
        icon,
      },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  // {
  //   subheader: "management",
  //   items: [
  //     {
  //       title: "user",
  //       path: PATH_DASHBOARD.user.root,
  //       icon: ICONS.user,
  //       children: [
  //         { title: "Four", path: PATH_DASHBOARD.user.four },
  //         { title: "Five", path: PATH_DASHBOARD.user.five },
  //         { title: "Six", path: PATH_DASHBOARD.user.six },
  //       ],
  //     },
  //   ],
  // },
];

export default navConfig;
